import type { LovDTO } from '@/features/api/extranet/dto/Lov'
import { isNullOrUndefined } from '@/features/shared/tools'

export const getLovIntitule = <T extends string | number>(lovDTO: LovDTO<T>, code?: T | null) => {
  if (isNullOrUndefined(code))
    return ''
  return lovDTO.filter((item) => item.code === code).at(0)?.intitule ?? ''
}